import { addToast } from '@app/components/various/Toasts';
import { updateLookbookPages } from '@app/services/lookbookRepository';
import { useMutation } from '@tanstack/react-query';
import { Lookbook } from '@typings';
import { useTranslation } from 'react-i18next';

interface Payload {
  lookbookId: string;
  data: Lookbook.UpdateLookbookPagesDTO;
}

export const useUpdateLookbookPages = () => {
  const { t } = useTranslation(['lookbook']);

  const handleError = () => {
    addToast(t('lookbook:lookbook_update_fail'), { type: 'error' });
  };

  const mutationFn = async ({ lookbookId, data }: Payload) => {
    return updateLookbookPages(lookbookId, data);
  };

  return useMutation({
    mutationFn,
    onError: handleError,
  });
};
